import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEScienceTargetType = {
    anatomy:        'anatomy'
};

OEScienceTargetType.all = [
    OEScienceTargetType.anatomy
];

export const OEScienceStartSelectionContent = {

    // alpha
    [OEScienceTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanBrainPotential,
                        OETargetMenuDefs.humanLiverSinusoid
                    ]
                }
            ]
        }
    ],

    // beta
    [OEScienceTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanBrainPotential,
                        OETargetMenuDefs.humanLiverSinusoid
                    ]
                }
            ]
        }
    ],

    // prod
    [OEScienceTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanBrainPotential,
                        OETargetMenuDefs.humanLiverSinusoid
                    ]
                }
            ]
        }
    ]
};

OEScienceStartSelectionContent.modules = [
    {id: OEScienceTargetType.anatomy, icon: OEIconCodes.science.anatomyTarget, categories: OEScienceStartSelectionContent[OEScienceTargetType.anatomy]},
];

OEScienceStartSelectionContent.modulesBeta = [
    {id: OEScienceTargetType.anatomy, icon: OEIconCodes.science.anatomyTarget, categories: OEScienceStartSelectionContent[OEScienceTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
];

OEScienceStartSelectionContent.modulesProduction = [
    {id: OEScienceTargetType.anatomy, icon: OEIconCodes.science.anatomyTarget, categories: OEScienceStartSelectionContent[OEScienceTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
];
